import gql from 'graphql-tag'

export const CommentsFetchQuery = gql`
  query CommentsQuery($commentable_id: ID!, $commentable_type: String!) {
    comments(commentable_id: $commentable_id, commentable_type: $commentable_type) {
      id
      comment
      updated_at
      user {
        id
        email
      }
    }
  }
`

export const createOrUpdateCommentsMutation = gql`
  mutation createOrUpdateComment (
    $id: ID,
    $commentable_id: ID!,
    $commentable_type: String!,
    $comment: String
  ) {
    createOrUpdateComment (
      id: $id,
      commentable_id: $commentable_id,
      commentable_type: $commentable_type,
      comment: $comment
    ) {
      comment {
        id
        comment
        updated_at
        user {
          id
          email
        }
      }
      errors
    }
  }
`

export const destroyCommentMutation = gql`
  mutation destroyComment($id: ID!) {
    destroyComment(id: $id) {
      response
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Comments/mutations.js